import { Box, Button, Card, CardContent, Grid } from '@mui/material';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import Chip from '@mui/material/Chip';
import type { IConfigDialogProp } from '../../../../types';
import { useTranslation } from 'react-i18next';
import sampleProductImage from '../../../assets/png/SamplePMImage.png';

/**
 * This component responsible to create the product card.
 * @prop {prod} is the product info
 * @callback {openDialog} is the call back function
 * @returns {JSX.Element}
 */

export const ProductCardComponent = ({
  prod,
  openDialog,
  showPackageType = false,
}: {
  prod: IConfigDialogProp;
  openDialog: (prod: IConfigDialogProp) => void;
  showPackageType?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Grid className="catalog-Container">
      <Card sx={{ border: '1px solid grey' }}>
        <CardContent className="catalog-cardLayout">
          <Box>
            <Box>
              <img
                src={sampleProductImage}
                className="catalog-image"
                alt="sample-pm-image"
              />
            </Box>

            <Box className="catalog-info">
              <Box>
                <span className="productCatalogCardHeader">{prod.productId}</span>
              </Box>
              <Box className="catalog-productDescription">
                <span className="text-capitalize productCatalogCardHeader">
                  {prod.productDescription}
                </span>
              </Box>

              <Box className="catalog-create-div">
                <Button
                  className="text-capitalize catalog-create"
                  data-testid="catalogCreate"
                  variant="contained"
                  onClick={() => openDialog(prod)}
                >
                  {'+ ' + t('button.configure')}
                </Button>
              </Box>
            </Box>
            <Box sx={{ display: 'inline-flex' }}>
              {showPackageType ? (
                <Chip
                  color="success"
                  size="small"
                  label={t('labels.packageType.' + prod.packageType)}
                />
              ) : (
                <StarOutlineOutlinedIcon />
              )}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};
